import request from '@/utils/http'

export class manageService {
  //仪表盘  总
  static statisticswhole() {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/whole'
      url: 'admin/crm/statistics/whole'
    })
  }
  //各渠道统计
  static channelcount() {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/channel/count'
      url: '/admin/crm/statistics/channel/count'
    })
  }
  //各国家统计
  static countrycount() {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/country/count'
      url: '/admin/crm/statistics/country/count'
    })
  }
  //跟单人统计
  static trackcount() {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/track/count'
      url: '/admin/crm/statistics/track/count'
    })
  }
  //每日录单统计
  static daycount() {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/day/count'
      url: '/admin/crm/statistics/day/count'
    })
  }
  //每日录单统计
  static inquirycount(params: any) {
    return request.get<any>({
      // url: '/admin/inquiry/statistics/inquiry/count',
      url: '/admin/crm/statistics/customer/count',
      params
    })
  }
  //询单列表
  static getinquiryList(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListData>({
      url: '/admin/inquiry/list',
      params
    })
  }
  // 获取详情
  static inquirydetail(params: any) {
    return request.get<any>({
      url: '/admin/inquiry/show',
      params
    })
  }
  //添加询单
  static inquiryAdd(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/inquiry/store',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //修改询单
  static inquiryedit(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/inquiry/update',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //删除询单
  static inquirydelete(params: any) {
    return request.get<Api.Common.AddResponse>({
      url: '/admin/inquiry/destroy',
      params
    })
  }
  //分配询单
  static inquiryallocation(params: any) {
    return request.post<Api.Work.AddResponse>({
      url: '/admin/inquiry/allocation',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //重新分配询单
  static inquiryreallocation(params: any) {
    return request.post<Api.Work.AddResponse>({
      url: '/admin/inquiry/reallocation',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }

  //发布询单
  static inquiryrelease(params: any) {
    return request.post<Api.Work.AddResponse>({
      url: '/admin/inquiry/release',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //获取用户下拉框
  static presetusers() {
    return request.get<any>({
      url: '/common/preset/users'
    })
  }
  //crm 客户管理
  //客户列表
  static getcrmCustomerList(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListDatad>({
      url: '/admin/crm/customer/list',
      params
    })
  }
  //客户导出
  static crmCustomerExport(params: any) {
    return request.get<any>({
      url: '/admin/crm/customer/export',
      params,
      responseType: 'blob' // 设置响应类型为 blob
    })
  }
  //客户审核
  static crmCustomerAudit(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/crm/customer/audit',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //客户转移
  static crmCustomerTransfer(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/crm/customer/transfer',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //用户列表
  static getUserList(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListData>({
      url: '/admin/user/list',
      params
    })
  }
  //用户编辑
  static userEdit(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/user/update',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //用户新增
  static userAdd(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/user/store',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //用户设置角色
  static userSetRole(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/user/authorize',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //用户菜单权限设置
  static userMenuAuth(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/user/set/resources',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //清除缓存
  static clearCache() {
    return request.get<any>({
      url: '/common/preset/cache/clear'
    })
  }
  //公海客户分配
  static crmCustomerAllocation(params: any) {
    return request.get<Api.Common.AddResponse>({
      url: '/admin/crm/customer/cede',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //公海客户跟进记录
  static crmCustomerFollow(params: any) {
    return request.get<any>({
      url: '/admin/crm/customer/follow',
      params: params
    })
  }
  //公海客户删除
  static crmCustomerDelete(params: any) {
    return request.get<Api.Common.AddResponse>({
      url: '/admin/crm/customer/delete',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //回收站 恢复
  static customerRestore(params: any) {
    return request.get<any>({
      url: '/admin/crm/customer/restore',
      params
    })
  }
  //备货单审核列表
  static getstocklist(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListData>({
      url: '/admin/approval/list',
      params
    })
  }
  //备货单审核
  static stockapproval(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/approval/store',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  // 审核更新
  static stockapprovalupdate(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/approval/update',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //审核详情
  static stockapprovaldetail(params: any) {
    return request.get<any>({
      url: '/admin/approval/show',
      params
    })
  }
  //审核删除
  static stockapprovaldelete(params: any) {
    return request.get<Api.Common.AddResponse>({
      url: '/admin/approval/destroy',
      params
    })
  }
  //审批记录
  static stockapprovalrecord(params: any) {
    return request.get<any>({
      url: '/admin/approval/records/todo',
      params
    })
  }
  //审批通过/拒绝
  static stockapprovalpass(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/approval/records/action',
      params
    })
  }
  //审批记录
  static stockapprovallogs(params: any) {
    return request.get<any>({
      url: '/admin/approval/records/logs',
      params
    })
  }
  //备货单
  static getStockList(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListData>({
      url: '/admin/stock/order/list',
      params
    })
  }
  //添加备货单
  static addStock(params: any) {
    return request.post<Api.Work.AddResponse>({
      url: '/admin/stock/order/store',
      params
      // showErrorMessage: false // 不显示错误消息
    })
  }
  //详情备货单
  static getStockDetail(params: any) {
    return request.get<any>({
      url: '/admin/stock/order/show',
      params
    })
  }
  //备货单查看
  static checkStock(params: any) {
    return request.get<any>({
      url: '/admin/stock/order/detail',
      params
    })
  }
  //打印
  static printStock(params: any) {
    return request.get<any>({
      url: '/admin/stock/order/print',
      params
    })
  }
  //审核详情
  static stockapprovaldetailborder(params: any) {
    return request.get<any>({
      url: '/admin/approval/records/border',
      params
    })
  }
  //审批转交
  static stockapprovaltransfer(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/admin/approval/records/transfer',
      params
    })
  }
  //审批时间轴
  static stockapprovaltimeline(params: any) {
    return request.get<any>({
      url: '/admin/approval/records/timeline',
      params
    })
  }
}
